module.exports = __webpack_public_path__ + "static/media/bars.c2f85e5b.svg";